import { render } from "./InterfaceTabs.vue?vue&type=template&id=686b8b44&scoped=true"
import script from "./InterfaceTabs.vue?vue&type=script&lang=js"
export * from "./InterfaceTabs.vue?vue&type=script&lang=js"

import "./InterfaceTabs.vue?vue&type=style&index=0&id=686b8b44&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686b8b44"]])

export default __exports__